import { http } from '@/services/api/client';
import type { CreateCommentPayload, ReportComment, UpdateCommentPayload } from '@/types/report';

export async function fetchCommentsByReport(reportId: string): Promise<ReportComment[]> {
  return http.get(`/comments/report/${reportId}`) as Promise<ReportComment[]>;
}

export async function markCommentRead(commentId: string): Promise<ReportComment> {
  return http.patch(`/comments/${commentId}/read`) as Promise<ReportComment>;
}

export async function createComment(payload: CreateCommentPayload): Promise<ReportComment> {
  return http.post('/comments', payload) as Promise<ReportComment>;
}

export async function updateComment(
  id: string,
  payload: UpdateCommentPayload,
): Promise<ReportComment> {
  return http.patch(`/comments/${id}`, payload) as Promise<ReportComment>;
}
